/**
 * A type representing the current state while solving the puzzle.
 */
// eslint-disable-next-line import/prefer-default-export
export enum AnswerState {
  INITIAL,
  COMPLETED_ERROR,
  COMPLETED_SUCCESS
}
